module.exports = __webpack_public_path__ + "static/media/private_inactive_1.8d0257b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bin/private_inactive_1.png
// module id = 3477
// module chunks = 0